import React from "react";
import { RouteComponentProps } from "react-router-dom";
import { connect } from "react-redux";
import { isPhone } from "@cadmakers-ui/core";
import FeedbackListContainer from "../../../Feedback/Components/Common/FeedbackList/FeedbackListContainer";
import { FeedbackCategory, FeedbackSortOption } from "../../../Feedback/Constants/feedbackEnums";
import { ActiveAppName, SubscriptionState, appService } from "../..";
import { SearchContextType } from "../../../Layout/Constants/LayoutEnums";
import { SearchContext } from "../../../Layout/Models/SearchContext";
import { IAppState } from "../../../Common";
import SubscribeToAppButtonContainer from "../Common/SubscribeToAppButton/SubscribeToAppButtonContainer";
import "../../Styles/ApplicationBugReportsContainer.scss";

type TParams = {
  id: string;
};

interface StateProps {
  appSubState: Record<string, SubscriptionState>;
}

const mapStateToProps = (state: IAppState): StateProps => ({
  appSubState: appService.getApplicationSubStatesFromAppState(state)
});

const CLASSNAME_PREFIX = "ApplicationBugReportsContainer__";
const FEEDBACK_TYPE = [FeedbackCategory.BugReport];

export const ApplicationBugReportsContainer: React.FC<RouteComponentProps<TParams> &
  StateProps> = props => {
  const context: SearchContext = {
    type: SearchContextType.App,
    itemId: props.match.params.id
  };

  return (
    <div>
      <div className={`${CLASSNAME_PREFIX}heading`}>
        <span className={`${CLASSNAME_PREFIX}heading-title`}>
          {!isPhone && (
            <h2>
              <ActiveAppName /> Bug Reports
            </h2>
          )}
        </span>
        <span className={`${CLASSNAME_PREFIX}heading-subscribe`}>
          {!isPhone && props.appSubState[props.match.params.id] === SubscriptionState.Active ? (
            <SubscribeToAppButtonContainer appId={props.match.params.id} />
          ) : null}
        </span>
      </div>
      <FeedbackListContainer
        listId={`APP_BUG_REPORT_LIST_${props.match.params.id}`}
        context={context}
        sort={FeedbackSortOption.DateCreated}
        isAscending={false}
        fullscreen
        enableDownload
        paging
        treeView
        selectedCategories={FEEDBACK_TYPE}
      />
    </div>
  );
};

export default connect(mapStateToProps)(ApplicationBugReportsContainer);
